export default "__VITE_ASSET__CNJVdvk7__"